import IconAction from '~/components/new/IconAction';
import { RemixIconNames } from '~/components/ui/Icon';
import { useQuickNav } from './QuickNavProvider';

export default function QuickNavTrigger() {
    const { isAvailable, open } = useQuickNav();

    if (!isAvailable) return null;

    const shortcut = navigator.platform.includes('Mac') ? '⌘K' : 'Ctrl+K';

    return (
        <IconAction
            className='quick-nav-trigger'
            icon={RemixIconNames.RiSearchLine}
            title={`Quick search · ${shortcut}`}
            colorVar='core-primary'
            onClick={() => open('icon')}
            data-test-component='QuickNav/Trigger'
        />
    );
}
